import { makeStyles } from '@material-ui/core';

export default makeStyles({
  image: {
    maxWeight: '150px',
    maxWidth: '150px',
    borderRadius: '20px',
  },
});
